import { withTheme } from 'emotion-theming'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'
import { withTranslation } from 'server/i18n'

import BlockTitle from 'components/BlockTitle'
import ContactMap from 'components/ContactMap'
import style from './LocationsMap.style'

const LocationsMapStyled = styled.div(props => ({ ...style(props) }))

const LocationsMap = ({ title, subtitle }) => {
    return (
        <LocationsMapStyled>
            <div className="LocationsMapTitleWrapper">
                <BlockTitle title={title} subtitle={subtitle} paddingLeft={0} />
            </div>
            <ContactMap />
        </LocationsMapStyled>
    )
}

LocationsMap.propTypes = {
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired
}

export default withTranslation()(withTheme(LocationsMap))
